var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgUnpin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3801 12.7524L11.3761 13.7573L6.11305 13.7207C5.92433 13.7207 5.75965 13.8364 5.68544 14.0063C5.61622 14.1772 5.65272 14.3745 5.78602 14.5083L17.7838 26.5059C17.8706 26.5928 17.9863 26.6392 18.1058 26.6392C18.1701 26.6392 18.2291 26.6255 18.2896 26.603C18.4594 26.5288 18.5701 26.354 18.565 26.1699L18.4367 20.8101L19.4368 19.8091L12.3801 12.7524Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9707 16.272L24.6746 14.5669L25.4192 15.3169C25.5073 15.3999 25.6217 15.4502 25.7462 15.4502C25.8657 15.4502 25.9866 15.3999 26.0734 15.3169L27.5552 13.8311C27.642 13.7432 27.6885 13.6284 27.6886 13.5044C27.6886 13.3848 27.6421 13.2656 27.5565 13.1821L19.0092 4.63477C18.8306 4.45508 18.5399 4.45508 18.3563 4.63477L16.8745 6.1167C16.7877 6.20459 16.7412 6.31934 16.7412 6.44385C16.7412 6.56348 16.7877 6.68262 16.8745 6.76562L17.6192 7.51025L15.9144 9.21582L22.9707 16.272Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38734 26.7866C4.26783 26.9702 4.29042 27.2144 4.44776 27.3667C4.48793 27.4067 4.53541 27.4385 4.58619 27.4609C4.64503 27.4868 4.70826 27.5 4.76979 27.5C4.85658 27.5 4.94459 27.4775 5.02259 27.4272L12.4944 22.5176L9.29689 19.3198L4.38734 26.7866Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20487 6.0419C9.69303 5.55374 10.4845 5.55374 10.9726 6.0419L26.1147 21.1839C26.6028 21.6721 26.6028 22.4635 26.1147 22.9517C25.6265 23.4398 24.8351 23.4398 24.3469 22.9517L9.20487 7.80966C8.71672 7.32151 8.71672 6.53005 9.20487 6.0419Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgUnpin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unpin.ede20cfec37992dbdbb0af7609b2486f.svg";